import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getReferralList } from "../../Redux/Actions/referralsAction";
import { ReferralLists } from "../../Global Functions/columnsAntd";
import TableComponentCp from "../../Global Functions/tableComponentsCp";
import DateRangePopup from "../../Utils/dateFilterPopup";
import toast from "react-hot-toast";

const ListReferrals = () => {
  const dispatch = useDispatch();

  const [searchQuery, setSearchQuery] = useState("");
  const [isDatePopupVisible, setIsDatePopupVisible] = useState(false);
  const [dateRange, setDateRange] = useState({ start: null, end: null });
  const [debouncedSearch, setDebouncedSearch] = useState(searchQuery);

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
    showSizeChanger: true,
    pageSizeOptions: ["5", "10", "20", "50", "100"],
  });

  const { referrals, loading } = useSelector((state) => state.referrals);

  const fetchDetails = useCallback(async (page, limit, showLoader = true) => {
    const referralData = {
      page,
      limit,
      // filter: searchQuery,
      booking_id: debouncedSearch,
      ...(dateRange.start && { start_date: dateRange.start.format("YYYY-MM-DD") }),
      ...(dateRange.end && { end_date: dateRange.end.format("YYYY-MM-DD") }),
    };
    try {
      await dispatch(getReferralList(referralData, showLoader));
      if (!showLoader) {
        toast.success("Referrals list refreshed");
      }
    } catch {
      if (!showLoader) {
        toast.error("Failed to refresh referrals list");
      }
    }
  },
    [dispatch, debouncedSearch, dateRange]
  )

  useEffect(() => {
    fetchDetails(pagination.current, pagination.pageSize);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.current, pagination.pageSize, fetchDetails]);

  useEffect(() => {
    if (referrals?.total) {
      setPagination((prevData) => ({ ...prevData, total: referrals.total }));
    }
  }, [referrals]);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(searchQuery);
    }, 500);

    return () => clearTimeout(handler);
  }, [searchQuery]);

  const handleDateRangeApply = (start, end) => {
    if (start === null && end === null) {
      setDateRange({ start: null, end: null });
    } else {
      setDateRange({ start, end });
    }
    setIsDatePopupVisible(false);
    setPagination((prev) => ({ ...prev, current: 1 }));
  };

  const handleTableChange = (pagination) => {
    setPagination(pagination);
  };

  return (
    <>
      <TableComponentCp
        h3heading="Booking Referrals List"
        setState={setSearchQuery}
        pagination={pagination}
        onChange={handleTableChange}
        onCalendarClick={() => setIsDatePopupVisible(true)}
        columns={ReferralLists(pagination.current, pagination.pageSize)}
        dataSource={(Array.isArray(referrals?.data) && referrals.data) || []}
        loading={loading}
      />

      <DateRangePopup
        visible={isDatePopupVisible}
        initialStart={dateRange.start}
        initialEnd={dateRange.end}
        onCancel={() => setIsDatePopupVisible(false)}
        onOk={handleDateRangeApply}
      />
    </>
  );
};

export default ListReferrals;
